import { useSyncExternalStore } from 'react';
import styles from './GlobalNotification.module.scss';

type Listener = () => void;

let message: string | null = null;
let timer: ReturnType<typeof setTimeout> | null = null;
const listeners = new Set<Listener>();

const notify = () => listeners.forEach((l) => l());

export const showNotification = (text: string) => {
  if (timer) clearTimeout(timer);
  message = text;
  notify();
  timer = setTimeout(() => {
    message = null;
    notify();
    timer = null;
  }, 3000);
};

const subscribe = (listener: Listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getSnapshot = () => message;

const GlobalNotification = () => {
  const msg = useSyncExternalStore(subscribe, getSnapshot);

  if (!msg) return null;

  return <div className={styles.notification}>{msg}</div>;
};

export default GlobalNotification;
